export default {
  title: 'Odbiorcy testowi',
  columns: {
    id: 'Id',
    phone_number: 'Numer telefonu',
  },
  filters: {
    search: {
      placeholder: 'Szukaj',
    },
  },
  buttons: {
    send_test: 'Wyślij test',
  },
  feedback: {
    success: 'Wysłano pomyślnie',
    error: 'Wysyłanie nie powiodło się',
  },
};
